var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 22",
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.629,
    y: 8.786,
    width: 4,
    height: 21,
    rx: 2,
    transform: "rotate(90 21.629 8.786)",
    fill: "#28272F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.1,
    y: 21.252,
    width: 4,
    height: 21,
    rx: 2,
    transform: "rotate(-180 13.1 21.252)",
    fill: "#28272F"
  })));
};
export { SvgPlus as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB2aWV3Qm94PSIwIDAgMjIgMjIiCiAgZmlsbD0ibm9uZSIKPgogIDxyZWN0CiAgICB4PSIyMS42Mjg5IgogICAgeT0iOC43ODU2NCIKICAgIHdpZHRoPSI0IgogICAgaGVpZ2h0PSIyMSIKICAgIHJ4PSIyIgogICAgdHJhbnNmb3JtPSJyb3RhdGUoOTAgMjEuNjI4OSA4Ljc4NTY0KSIKICAgIGZpbGw9IiMyODI3MkYiCiAgLz4KICA8cmVjdAogICAgeD0iMTMuMDk5NiIKICAgIHk9IjIxLjI1MjQiCiAgICB3aWR0aD0iNCIKICAgIGhlaWdodD0iMjEiCiAgICByeD0iMiIKICAgIHRyYW5zZm9ybT0icm90YXRlKC0xODAgMTMuMDk5NiAyMS4yNTI0KSIKICAgIGZpbGw9IiMyODI3MkYiCiAgLz4KPC9zdmc+";